import { render } from "./MainCarouselImage.vue?vue&type=template&id=5da2076f&scoped=true"
import script from "./MainCarouselImage.vue?vue&type=script&lang=js"
export * from "./MainCarouselImage.vue?vue&type=script&lang=js"

import "./MainCarouselImage.vue?vue&type=style&index=0&id=5da2076f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da2076f"]])

export default __exports__